import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_question_answer_image_uploader = _resolveComponent("question-answer-image-uploader");
  return _openBlock(), _createBlock(_component_question_answer_image_uploader, {
    image: _ctx.responseImage,
    onImageUploaded: _ctx.onImageUploaded,
    onImageDelete: _ctx.onImageDelete
  }, null, 8, ["image", "onImageUploaded", "onImageDelete"]);
}